export const ADD_SELECTED_ELEMENT = 'selectedElemenstTypes/ADD_SELECTED_ELEMENT';
export const REMOVE_ALL_SELECTED_ELEMENTS = 'selectedElementsTypes/REMOVE_ALL_SELECTED_ELEMENTS';
export const REMOVE_SELECTED_ELEMENT = 'selectedElementsTypes/REMOVE_SELECTED_ELEMENT';
export const SELECT_ALL_ELEMENTS = 'selectedElementsTypes/SELECT_ALL_ELEMENTS';
